<script setup>
import {useMainOrdersStore} from "@/stores/mainOrders.js"
import {useSupplierStockStore} from "@/stores/supplierStock.js";
import {useConfigStore} from "@/stores/config.js"
import {useUserStore} from "@/stores/user.js";
import {computed, onMounted, ref} from "vue";
import Button from "@/components/Button/index.vue";
import GamesSkeleton from "@/components/Skeleton/Games.vue";
import {useRouter, useRoute} from "vue-router";
import Breadcrumbs from "@/components/Breadcrumbs/index.vue";
import {showMessage} from "@/utils/showMessage.js";

/* ---------- vue-router ---------- */
const router = useRouter();
const route = useRoute();

/* ---------- Stores ---------- */
const ordersStore = useMainOrdersStore()
const configStore = useConfigStore()
const userStore = useUserStore()
const supplierStockStore = useSupplierStockStore();
const games = computed(() => configStore.getAllGames || [])
const loading = ref(false)
const stocks = ref(null)
const stockGames = ref(null)
const result = ref(null)
const hasSettingsAccess = computed(() => userStore.hasPermission("STOCKS_MANAGER_ACCESS") || userStore.hasPermission('BIG_BOSS'))

function onGameClick(game) {
  router.push({name: 'stocks-supplier-game', params: {game: game.abbreviation}})
}

const fetchInitialData = async () => {
  try {
    loading.value = true
    const res = await supplierStockStore.action_getMenu();
    if (res.result === true) {
      stocks.value = res.data
      stockGames.value = stocks.value.map(s => s.game)
      result.value = games.value.filter(g => stockGames.value.includes(g.game))
    } else {
      showMessage(res, 'error')
    }
  } catch (err) {
    showMessage(err, 'error')
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchInitialData()
})
</script>

<template>
  <div>
    <div class="flex flex-col gap-4 w-full h-full">
      <div class="flex flex-row justify-between gap-4 w-full">
        <Breadcrumbs/>
        <div v-if="hasSettingsAccess">
          <router-link :to="{name: 'stocks-supplier-settings'}"
                       class="btn btn-outline-dark py-1 text-xs font-medium rounded-md">
            Settings
          </router-link>
        </div>
      </div>
      <div v-if="games" class="grid xl:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-1 gap-4">
        <div v-for="(game, index) in result" class="aspect-[16/9] rounded-2xl relative overflow-hidden cursor-pointer"
             @click="onGameClick(game)">
          <img :src="game.banner" alt="" class="w-full h-full">
          <button
              class="absolute bottom-0 p-2 flex justify-center items-center w-full bg-black-500/60 text-white text-xs">
            {{ game.game }}
          </button>
        </div>
      </div>
      <GamesSkeleton v-else></GamesSkeleton>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>